import { StyleSheet } from "@react-pdf/renderer";

export const productsDataStyles=()=>{

    const productsData = StyleSheet.create({
        titleRow: {
            height:16,
            flexDirection: 'row',
            borderLeftWidth: 1,
            borderBottomWidth: 1,
            backgroundColor: 'rgb(229, 229, 229)',
            width: '100%',
            justifyContent: 'center',
        },
        row: {
            flexDirection: 'row',
            backgroundColor: 'rgb(245, 245, 245)',
            justifyContent: 'center',
            borderBottomWidth: 1
        },

    });

    return {
        productsData
    }
}